import {
	all,
	call,
	debounce,
	put,
	select,
	takeLatest,
} from "redux-saga/effects";
import {
	ACCOUNT_REGISTER,
	ACCOUNT_REGISTER_PROFILE,
	ACCOUNT_UPDATE_USER,
	ADD_PERMISSIONS_LIST,
	CHANGE_USER_PASSWORD,
	CHANGE_USER_PASSWORD_TOKEN,
	FORGOT_PASSWORD,
	DELETE_PERMISSIONS_LIST,
	DELETE_USER,
	GENERATE_PASSWORD_RESET_TOKEN,
	GetCurrentUserPermissionsSuccess,
	GetCurrentUserDictionarySuccess,
	GetUserPreferencesSuccess,
	GET_CHAT_USER_ALL,
	GET_CURRENT_USER_PERMISSIONS,
	GET_CURRENT_USER_DICTIONARY,
	GET_USERS_ALL,
	GET_USERS_BY_ID,
	GET_USER_AND_PROFILES_ALL,
	GET_USER_PERMISSIONS,
	GET_USER_PREFERENCES,
	REGISTER_USER_SAGA,
	UpdateUserPreferencesSuccess,
	UPDATE_USER_SAGA, 
	UPDATE_USER_PREFERENCES,
	VERIFY_USER_NAME,
} from "../actions/account-action-types";
import {
	changeLanguage
} from "../actions/user-action-types";
import {
	formattedDateTime
} from "../../utilities/dateFormatter";

import httpClient from "./http-client";

function* GetUserAll({ payload: { page, perPage, search, callback } }) {
	const payloadObj = {
		method: "get",
		url: `Account/GetUserAll`,
		params: { pr: perPage, pi: page, userName: search }
	};

	const { error, result } = yield call(httpClient, payloadObj, true, true);
	if (callback) {
		callback({ error, result });
	}
	return { error, result };
}

function* GetUserById({ payload: { id, callback } }) {
	const payloadObj = {
		data: id,
		method: "get",
		url: `Account/GetUserById?userId=${id}`,
	};

	const { error, result } = yield call(httpClient, payloadObj, true, true);
	console.log({ error, result });
	if (error) {
	} else {
		result.data.userCreatedDate = formattedDateTime(result.data.userCreatedDate);
		
	}
	if(callback){
		callback({ result, error });
	}
	return { result, error };
}

function* VerifyUserName({ payload: { data, callback } }) {
	const payloadObj = {
		data,
		method: "post",
		url: `Account/VerifyUserName`,
	};

	const { error, result } = yield call(httpClient, payloadObj, true, false);

	if (error) {
	} else {
	}
	if(callback){
		callback({ result, error });
	}
	return { error, result };
}

function* GeneratePasswordResetToken({ payload: { userId, callback } }) {
	const payloadObj = {
		data: userId,
		method: "post",
		url: `Account/GeneratePasswordResetToken?id=${userId}`,
	};

	const { error, result } = yield call(httpClient, payloadObj, true, true);

	if (callback) {
		callback({ result, error });
	}

	return { error, result };
}

function* ForgotPassword({ payload: { data, callback } }) {
	const payloadObj = {
		data,
		method: "post",
		url: "Account/ForgotUserPassword",
	};
	
	const { result, error } = yield call(httpClient, payloadObj, true, false);

	if (callback) {
		callback({ result, error });
	}

	return { error, result };
}

function* ChangeUserPassword({ payload: { data, callback } }) {
	const payloadObj = {
		data,
		method: "post",
		url: `Account/ChangeUserPassword`,
	};
	const { error, result } = yield call(httpClient, payloadObj, true, true);

	if (callback) {
		callback({ result, error });
	}

	return { error, result };
}

function* ChangeUserPasswordToken({ payload: { data, callback } }) {
	const payloadObj = {
		data,
		method: "post",
		url: `Account/ChangeUserPasswordToken`,
	};
	const { error, result } = yield call(httpClient, payloadObj, true, false);

	if (callback) {
		callback({ result, error });
	}

	return { error, result };
}

function* DeleteUser({ payload: { data, history } }) {
	const payloadObj = {
		data: data.id,
		method: "delete",
		url: `Account/DeleteUser?id=${data.id}`,
	};

	const { result, error } = yield call(httpClient, payloadObj, true, true);

	if (error) {
	} else {
		history.push("/settings/setup/users");
	}
	return { result, error };
}

function* GetUserPermissions({ payload: { id, callback } }) {

	const payloadObj = {
		method: "get",
		url: `Account/GetUserPermissions?id=${id}`,
	};

	const { error, result } = yield call(httpClient, payloadObj, true, true);

	if (error) {
	} else {
	}

	if (callback) {
		callback({ result, error });
	}
	
	return { error, result };
}

function* Register({ payload: { data } }) {
	const payloadObj = {
		data,
		method: "post",
		url: `Account/Register`,
	};

	let { error, result } = yield call(httpClient, payloadObj, true, true);

	if (error || !result?.data) {
	} else {
		result.data.userCreatedDate = formattedDateTime(result.data.userCreatedDate);
	}

	return { error, result };
}

function* RegisterProfile({ payload: { data, callback } }) {
	const payloadObj = {
		data: { profileName: data.userName },
		method: "post",
		url: `Account/RegisterProfile`,
	};

	const { result, error } = yield call(httpClient, payloadObj, true, true);

	if (error || !result?.data) {
		error = result.message;
	} else {
		result.data.userCreatedDate = formattedDateTime(result.data.userCreatedDate);
	}
	if (callback) {
		callback({ error, result });
	}
	
	return { result, error };
}

function* RegisterUserSaga({ payload: { data, history, callback } }) {
	const { result, error } = yield call(VerifyUserName, {
		payload: { data: JSON.stringify(data.userName) },
	});
	if (!error) {
		if (data.isProfile === true) {
			yield call(RegisterProfile, { payload: { data, callback } });
		} else {
			const { error, result } = yield call(Register, {
				payload: { data, history },
			});
			if (!error) {
				const { errorUpd, resultUpd } = yield call(UpdateUser, {
					payload: { data: { ...result.data, ...data } },
				});
				if (callback) {
					result.data.userCreatedDate = formattedDateTime(result.data.userCreatedDate);
					callback({ error, result });
				}
				return { error, result };
			} else {
				console.error(error);
			}
		}
	} else {
		console.error(error);
	}
	
	return { result, error };
}

function* UpdateUser({ payload: { data, callback } }) {
	const payloadObj = {
		data,
		method: "post",
		url: `Account/UpdateUser`,
	};

	const { result, error } = yield call(httpClient, payloadObj, true, true);

	if (error) {
	} else {
	}
	if(callback)
		callback({ result, error });
	
	return { result, error };
}

function* UpdateUserSaga({ payload: { data, callback } }) {
	let toUpdateValues = data.origValues;

	let err1, err2, err3, err4, err5, result, tokenResult, res3;
	
	if (data.values.password?.length > 0) {
		({ error: err2, result: tokenResult } = yield call(
			GeneratePasswordResetToken,
			{
				payload: { userId: toUpdateValues.id },
			}
		));
		let token = tokenResult.data;
		// console.log({ tokenResult });
		if (token) {
			({ error: err3, result: res3 } = yield call(ChangeUserPassword, {
				payload: {
					data: {
						password: toUpdateValues.password,
						passwordToken: token,
						userName: toUpdateValues.userName,
					},
				},
			}));
		}
		if (Boolean(!err2 || !err3)) {
			delete toUpdateValues.password;
		}
	}
	
	if (data.DeletePermissionArray?.length) {
		({ error: err5 } = yield call(DelPermissionsList, {
			payload: { data: data.DeletePermissionArray }
		}));
	}

	if (data.AddPermissionArray?.length) {
		({ error: err4 } = yield call(AddPermissionsList, {
			payload: { data: data.AddPermissionArray },
		}));
	}

	if (!Boolean(err1 || err2 || err3 || err4)) {
		yield call(UpdateUser, {
			payload: { data: toUpdateValues, callback },
		});
	}
}

function* AddPermissionsList({ payload: { data, callback } }) {
	const payloadObj = {
		data,
		method: "post",
		url: `Account/AddPermissionsList`,
	};

	const { result, error } = yield call(httpClient, payloadObj, true, true);

	if (error) {
	} else {
	}
	return { result, error };
}

function* DelPermissionsList({ payload: { data, callback } }) {
	const payloadObj = {
		data,
		method: "post",
		url: `Account/DelPermissionsList`,
	};

	const { result, error } = yield call(httpClient, payloadObj, true, true);

	if (error) {
	} else {
	}
	return { result, error };
}

export function* GetCurrentUserPermissions() {
	const payloadObj = {
		method: "get",
		url: `Account/GetCurrentUserPermissions`,
	};

	const { error, result } = yield call(httpClient, payloadObj, true, true);
	console.log({ error, result });
	if (error) {
	} else {
		yield put(GetCurrentUserPermissionsSuccess(result.data));
	}
	return { result, error };
}

export function* GetCurrentUserDictionary() {
	const payloadObj = {
		method: "get",
		url: `Reporting/GetCustomSpellingDictionary`,
	};

	const { error, result } = yield call(httpClient, payloadObj, true, false);
	console.log({ error, result });
	if (error) {
	} else {
		yield put(GetCurrentUserDictionarySuccess(result.data));
	}
	return { result, error };
}

function* GetChatUserAll({ payload: { userName = null, callback = null } }) {
	const payloadObj = {
		method: "get",
		url: `Account/GetChatUserAll?pr=1000`,
	};

	if (userName) payloadObj.params = { userName: userName };

	const { error, result } = yield call(httpClient, payloadObj, true, true);
	if (error) {
	} else {
	}
	if (callback) {
		callback({ error, result });
	}
	return { result, error };
}

function* GetUserAndProfilesAll({
	payload: { page, perPage, userName, callback },
}) {
	console.log("here?");

	const payloadObj = {
		method: "get",
		url: `Account/GetUserAndProfilesListAll`,
		params: { pr: perPage, pi: page, userName },
	};

	const { error, result } = yield call(httpClient, payloadObj, true, true);

	if (error) {
	} else {
	}
	if (callback) {
		callback({ error, result });
	}

	return { error, result };
}

export function* GetUserPreferences(payload) {
	const currentUserId = yield select(
		({ session: { userInfo } }) => userInfo.id
	);


	const payloadObj = {
		method: "get",
		url: `Account/GetUserPreferences`,
		params: { userId: currentUserId },
	};

	const { error, result } = yield call(httpClient, payloadObj, true, true);

	if (error) {
	} else {
		yield put(GetUserPreferencesSuccess(result?.data));
	}
	if (payload?.callback) 
		payload.callback({ result, error });

	return { error, result };
}

function* UpdateUserPreferences({ payload: {data, callback} }) {

	const currentUserId = yield select(
		({ session: { userInfo } }) => userInfo.id
	);
	const userPreferences = yield select(
		({ session: { userPreferences } }) => userPreferences
	);
	let changeLang = (data.language??userPreferences?.language) !== userPreferences?.language;

	const payloadObj = {
		data: {
			userId: currentUserId,
			preferences: { ...userPreferences, ...data },
		},
		method: "post",
		url: `Account/UpdateUserPreferences`,
	};

	const { result, error } = yield call(httpClient, payloadObj, true, true);

	if (error) {
	} else {
		if(changeLang){
			yield put(changeLanguage(data.language));
		}

		yield put(UpdateUserPreferencesSuccess(data));
		if(callback){
			callback({ result, error });
		}
	}
	return { error, result };
}

function* accounts() {
	yield all([
		takeLatest(GET_USERS_ALL, GetUserAll),
		takeLatest(GET_USERS_BY_ID, GetUserById),
		takeLatest(VERIFY_USER_NAME, VerifyUserName),
		takeLatest(ACCOUNT_UPDATE_USER, UpdateUser),
		takeLatest(GENERATE_PASSWORD_RESET_TOKEN, GeneratePasswordResetToken),
		takeLatest(CHANGE_USER_PASSWORD, ChangeUserPassword),
		takeLatest(CHANGE_USER_PASSWORD_TOKEN, ChangeUserPasswordToken),
		takeLatest(FORGOT_PASSWORD, ForgotPassword),
		takeLatest(DELETE_USER, DeleteUser),
		takeLatest(GET_USER_PERMISSIONS, GetUserPermissions),
		takeLatest(ACCOUNT_REGISTER, Register),
		takeLatest(ACCOUNT_REGISTER_PROFILE, RegisterProfile),
		takeLatest(REGISTER_USER_SAGA, RegisterUserSaga),
		takeLatest(UPDATE_USER_SAGA, UpdateUserSaga),
		takeLatest(ADD_PERMISSIONS_LIST, AddPermissionsList),
		takeLatest(DELETE_PERMISSIONS_LIST, DelPermissionsList),
		takeLatest(GET_CURRENT_USER_PERMISSIONS, GetCurrentUserPermissions),
		takeLatest(GET_CURRENT_USER_DICTIONARY, GetCurrentUserDictionary),
		debounce(200, GET_USER_AND_PROFILES_ALL, GetUserAndProfilesAll),
		debounce(200, GET_CHAT_USER_ALL, GetChatUserAll),
		takeLatest(GET_USER_PREFERENCES, GetUserPreferences),
		takeLatest(UPDATE_USER_PREFERENCES, UpdateUserPreferences),
	]);
}

export default accounts;
